/** The billing page's query string: how Stripe Checkout ended, when it sends the browser back. */

export type BillingSearch = { checkout?: "done" | "canceled" };

export function parseBillingSearch(search: Record<string, unknown>): BillingSearch {
  return search.checkout === "done" || search.checkout === "canceled"
    ? { checkout: search.checkout }
    : {};
}
